var DEFAULT_WIDTH_RATIO = 5;
var DEFAULT_HEIGHT_RATIO = 3;
var ratioQuerySetter = function ratioQuerySetter(url, value) {
  var location = new URL(url, "https://dummy.com");
  location.searchParams.set("type", "ratio");
  location.searchParams.set("value", value);
  return location.toString();
};
function replaceRatio(src, ratio) {
  return src && ratio ? ratioQuerySetter(decodeURIComponent(src), ratio) : src;
}
function parseRatio(value, defaultRatio) {
  var _a, _b;
  var widthRatio = (_a = defaultRatio === null || defaultRatio === void 0 ? void 0 : defaultRatio.width) !== null && _a !== void 0 ? _a : DEFAULT_WIDTH_RATIO;
  var heightRatio = (_b = defaultRatio === null || defaultRatio === void 0 ? void 0 : defaultRatio.height) !== null && _b !== void 0 ? _b : DEFAULT_HEIGHT_RATIO;
  if (value) {
    var ratio = value.split(":");
    widthRatio = parseInt(ratio[0], 10) || DEFAULT_WIDTH_RATIO;
    heightRatio = parseInt(ratio[1], 10) || DEFAULT_HEIGHT_RATIO;
  }
  return {
    width: widthRatio,
    height: heightRatio
  };
}

export { parseRatio, replaceRatio };
